import { App } from 'vue'
import DataTable from './DataTable.vue'
import ExpandableDataTable from './ExpandableDataTable.vue'
import ExpandedPanel from './ExpandedPanel.vue'
import ExpandedSection from './ExpandedSection.vue'
import ExpandedSectionElement from './ExpandedSectionElement.vue'

const datatable = {
  DataTable,
  ExpandableDataTable,
  ExpandedPanel,
  ExpandedSection,
  ExpandedSectionElement,
}

for (const elem in datatable) {
  if (datatable.hasOwnProperty(elem)) {
    // @ts-ignore
    const element = datatable[elem]
    element.install = (Vue: App) => {
      Vue.component(element.name, element)
    }
  }
}

export default datatable
